import React, { useState } from 'react'
import { Button, ButtonToolbar, Panel } from 'rsuite'
import { SaveButton } from '@components/common/form/Buttons'
import EditIcon from '@rsuite/icons/Edit'

interface SavablePanelProps {
  header: string
  loading?: boolean
  saving?: boolean
  onSave?: () => void
  /** Read-only view shown when not editing */
  readView?: React.ReactNode
  /** Editable form content (children) */
  children: React.ReactNode
  className?: string
  /** If true, panel is always in edit mode (no toggle) */
  alwaysEditable?: boolean
}

export default function SavablePanel ({
  header,
  loading = false,
  saving = false,
  onSave,
  readView,
  children,
  className = 'my-5',
  alwaysEditable = false
}: SavablePanelProps) {
  const [ editing, setEditing ] = useState(alwaysEditable)

  const handleSave = () => {
    onSave?.()
    if (!alwaysEditable) {
      setEditing(false)
    }
  }

  const handleCancel = () => {
    setEditing(false)
  }

  const panelHeader = (
    <div className="flex justify-between items-center">
      <span>{header}</span>
      {!alwaysEditable && readView && onSave && (
        editing ? (
          <Button
            appearance="subtle"
            onClick={(e) => {
              e.stopPropagation()
              handleCancel()
            }}
            size="sm"
            disabled={saving}
          >
            Отмена
          </Button>
        ) : (
          <Button
            appearance="link"
            startIcon={<EditIcon />}
            onClick={(e) => {
              e.stopPropagation()
              setEditing(true)
            }}
            size="sm"
          >
            Изменить
          </Button>
        )
      )}
    </div>
  )

  return (
    <Panel shaded header={panelHeader} className={className}>
      {editing || alwaysEditable || !readView ? (
        <>
          {children}
          {onSave && (
            <div className="mt-4 flex justify-end">
              <SaveButton
                loading={loading || saving}
                disabled={loading || saving}
                onClick={handleSave}
              >
                Сохранить
              </SaveButton>
            </div>
          )}
        </>
      ) : (
        readView
      )}
    </Panel>
  )
}
